import React from 'react';
import { Link } from 'react-router-dom';
import { HugeiconsIcon } from '@hugeicons/react';
import { Calendar03Icon } from '@hugeicons/core-free-icons';

/**
 * Where an agent page sits inside the events platform, above its title: the event, then the
 * workflow ("qa test / Activation Workflow"). Each part links back to its page.
 */
function EventContextTrail({ items = [] }) {
  const parts = items.filter(item => item?.label);
  if (!parts.length) return null;

  return (
    <nav aria-label="Event" className="flex min-w-0 items-center gap-1.5 text-[13px]">
      <HugeiconsIcon
        icon={Calendar03Icon}
        strokeWidth={2}
        className="size-3.5 shrink-0 text-muted-foreground"
      />
      {parts.map((item, index) => (
        <React.Fragment key={`${item.label}-${index}`}>
          {index > 0 && (
            <span aria-hidden className="text-muted-foreground/50">
              /
            </span>
          )}
          {item.path ? (
            <Link
              to={item.path}
              className="min-w-0 truncate rounded-sm font-medium text-muted-foreground transition-colors duration-150 ease-out-quad outline-none hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring/50"
            >
              {item.label}
            </Link>
          ) : (
            <span className="min-w-0 truncate font-medium text-muted-foreground">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}

export default EventContextTrail;
